const QrCode = () => import("@/views/fap/qrcode");

const routes = [
    {
        path: "/qrcode/fap/:id",
        name: "fapQrcode",
        meta: {
            title: "微信跳转"
        },
        component: QrCode
    },
    {
        path: "/qrcode/fap",
        name: "fapQrcodes",
        meta: {
            title: "微信跳转"
        },
        component: QrCode
    }
];
export default routes;
